import { EditableContent } from '../../../edit/EditableContent';
import type { BlockRenderProps } from '../../../types';
import { MenuItemDietaryTags } from '../MenuItemTags';
import { isMenuItemActive } from '../menuEditHelpers';
import { readHighlightMenuSection } from './highlightMenuItems';

/** Story tiles — short dish intros in a compact grid (layout id kept as price tiles). */
export function MenuHighlightPriceTiles({
  block,
  locale,
  isActive,
  activeEditTarget,
  editable,
}: BlockRenderProps) {
  const { sectionTitle, sectionSubtitle, dishes } = readHighlightMenuSection(
    block,
    locale,
  );
  const target = isActive ? activeEditTarget : null;

  return (
    <section
      className={['ws-hl-price', isActive ? 'ws-block--active' : ''].filter(Boolean).join(' ')}
      data-block-id={block.blockId}
      data-component={block.componentType}
      data-registry-key={block.registryBlockKey}
      id="menu"
    >
      <div className="ws-hl-price__inner">
        <header className="ws-hl-price__intro">
          <EditableContent
            as="h2"
            fieldKey="sectionTitle"
            editable={editable}
            activeEditTarget={target}
            className="ws-hl-price__title"
          >
            {sectionTitle}
          </EditableContent>
          {sectionSubtitle || editable ? (
            <EditableContent
              as="p"
              fieldKey="sectionSubtitle"
              editable={editable}
              activeEditTarget={target}
              className="ws-hl-price__subtitle"
            >
              {sectionSubtitle}
            </EditableContent>
          ) : null}
        </header>
        <ul className="ws-hl-price__grid">
          {dishes.map(({ item, columnIndex, itemIndex }) => (
            <li
              key={`${columnIndex}-${itemIndex}`}
              className={[
                'ws-hl-price__tile',
                isMenuItemActive(
                  target?.kind === 'menu-item' ? target : null,
                  columnIndex,
                  itemIndex,
                )
                  ? 'ws-edit-child--active'
                  : '',
              ]
                .filter(Boolean)
                .join(' ')}
              {...(editable
                ? {
                    'data-edit-child': 'menu-item' as const,
                    'data-column-index': columnIndex,
                    'data-item-index': itemIndex,
                  }
                : {})}
            >
              <div className="ws-hl-price__head">
                <p className="ws-hl-price__name">{item.name}</p>
                <MenuItemDietaryTags
                  item={item}
                  locale={locale}
                  iconsOnly
                  placement="inline"
                />
              </div>
              {item.description ? (
                <p className="ws-hl-price__desc">{item.description}</p>
              ) : null}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
